(() => {
  window.coffeeProductLifecycle?.destroy?.();

  const syncDisclosureState = (root = document) => {
    root.querySelectorAll('.coffee-product__accordion details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary || summary.dataset.coffeeBound === 'true') return;
      const update = () => summary.setAttribute('aria-expanded', String(details.open));
      summary.dataset.coffeeBound = 'true';
      details.addEventListener('toggle', update);
      update();
    });
  };

  const updateCoffeeContent = ({ data }) => {
    const productInfo = document.querySelector(`product-info[data-section="${CSS.escape(data.sectionId)}"]`);
    if (!productInfo) return;
    ['CoffeeDelivery'].forEach((prefix) => {
      const current = productInfo.querySelector(`#${prefix}-${CSS.escape(data.sectionId)}`);
      const updated = data.html.getElementById(`${prefix}-${data.sectionId}`);
      if (!current || !updated) return;
      current.innerHTML = updated.innerHTML;
      current.classList.toggle('hidden', updated.classList.contains('hidden'));
    });
    syncDisclosureState(productInfo);
  };

  const onReady = () => syncDisclosureState();
  const onProductInfoLoaded = (event) => syncDisclosureState(event.target);
  const onSectionLoad = (event) => syncDisclosureState(event.target);
  document.addEventListener('DOMContentLoaded', onReady);
  document.addEventListener('product-info:loaded', onProductInfoLoaded);
  document.addEventListener('shopify:section:load', onSectionLoad);

  let unsubscribeVariantChange;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, updateCoffeeContent);
  }

  window.coffeeProductLifecycle = {
    destroy() {
      document.removeEventListener('DOMContentLoaded', onReady);
      document.removeEventListener('product-info:loaded', onProductInfoLoaded);
      document.removeEventListener('shopify:section:load', onSectionLoad);
      unsubscribeVariantChange?.();
    },
  };
})();
